import * as React from "react";
import { useApiService, useCommonHooks } from "../../../hooks";
import {
  FunctionalDirectorApi,
  FunctionalDirectorGridDto,
  FunctionalDirectorSearchCriterias,
  SearchQueryOfFunctionalDirectorSearchCriterias,
} from "../../../api";
import { IDataTableColumn, SearchQuery } from "nsitools-react";
import { CustomBreadcrumbProps, PageBase } from "../../../components";
import { AdvancedSearchTable } from "../../../components/searchTable/AdvancedSearchTable";
import { ERoutes } from "../../../AppRouter";

export interface IFunctionalDirectorListPageProps {}

export const FunctionalDirectorListPage: React.FunctionComponent<
  IFunctionalDirectorListPageProps
> = () => {
  const { t, router } = useCommonHooks();
  const api = useApiService(FunctionalDirectorApi);

  const getSearchCriterias = React.useCallback(() => {
    return api.getSearchCriterias(true, null);
  }, [api]);

  const search = React.useCallback(
    (searchQuery: SearchQuery<FunctionalDirectorSearchCriterias>) => {
      return api.baseSearch(
        SearchQueryOfFunctionalDirectorSearchCriterias.fromJS(searchQuery)
      );
    },
    [api]
  );

  const columns = React.useMemo<IDataTableColumn<FunctionalDirectorGridDto>[]>(
    () => [
      {
        fieldName: "functionalDirectorName",
        header: () => t("FunctionalDirectorName"),
      },
      {
        fieldName: "agent",
        header: () => t("Agent"),
      },
    ],
    [t]
  );

  const breadCrumbs = React.useMemo<CustomBreadcrumbProps[]>(
    () => [{ text: t("FunctionalDirectorList") }],
    [t]
  );

  const onRowClick = React.useCallback(
    (f: FunctionalDirectorGridDto) => {
      router.goToEditPage(ERoutes.functionalDirectors, f.id, "details");
    },
    [router]
  );

  return (
    <PageBase breadCrumbs={breadCrumbs}>
      <AdvancedSearchTable
        sortKeys={{ functionalDirectorName: "ASC" }}
        searchFunction={search}
        getCriteriasFunction={getSearchCriterias}
        columns={columns}
        onRowClick={onRowClick}
      />
    </PageBase>
  );
};

export default FunctionalDirectorListPage;
